export const DEFAULT_SCROLL_THRESHOLD = 50;
export const SCROLL_THROTTLE_MS = 16; // ~60fps
export const TRANSLUCENT_OPACITY_SUFFIX = 'CC'; // 80% opacity in hex
